import { Injectable } from '@angular/core';
import { ToastController, Platform, LoadingController, AlertController, ModalController, PopoverController } from '@ionic/angular';
import { VariablesService } from './variables.service';

import { Plugins } from '@capacitor/core';
// const { LocalNotifications } = Plugins;

@Injectable({
  providedIn: 'root'
})
export class LlamadasAlertsService {

  loadingObject;

  constructor(
    private toastController: ToastController,
    private loadingCtrl: LoadingController,
    private alertController: AlertController,
  ) {
    this.loadingObject = null;
  }

  async presentLoading(mensaje?: string) {
    if (this.loadingObject == null) {
      if (mensaje != null) {
        this.loadingObject = await this.loadingCtrl.create({
          message: mensaje
        })
        await this.loadingObject.present();

      } else {
        this.loadingObject = await this.loadingCtrl.create()
        await this.loadingObject.present();
      }
    }
  }

  async presentAlertLoginOffline(fichaje) {

    const alert = await this.alertController.create({
      header: 'Login sin internet',
      message: 'Estás intentando hacer login sin conexión a internet, si su propósito es realizar un fichaje pulse el botón de fichaje sin conexión',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Fichar sin internet',
          handler: () => {

          }
        }
      ]
    })
  }



  async presentToast(texto: string, color?: string, tiempo?: number, position?: "top" | "bottom" | "middle") {
    if (color == null) { color = 'success' };
    if (tiempo == null) { tiempo = 2000 };
    const toast = await this.toastController.create({
      position: position,
      message: texto,
      duration: tiempo,
      color: color
    });
    toast.present();

  }

  async presentAlert(hearder: string, subhearder: string, message?: string, buttons?: string) {
    if (buttons == null) buttons = "De acuerdo";
    const alert = await this.alertController.create({
      header: hearder,
      subHeader: subhearder,
      message: message,
      buttons: [buttons]
    });

    await alert.present();
  }

  

  

  async elegirMensajeNotificacion(numeroFichajes: number, numeroFichajesCorrectos: number, numeroFichajesIncorrectos: number, numeroFichajesProduccionCorrectos: number,
    numeroFichajesProduccionIncorrectos: number, erroresServicio: boolean, erroresServicioSecundario: boolean, mensajeServicio: string): Promise<string> {

    let mensaje = "";

    if (erroresServicio == true && erroresServicioSecundario == false) {
      if (numeroFichajesProduccionIncorrectos > 0) {
        if (numeroFichajesCorrectos > 0) {
          mensaje = "Ha ocurrido un error: Se han enviado al servidor " + numeroFichajesProduccionCorrectos + " fichajes de produccion y " + numeroFichajesCorrectos + " fichajes normales de los " + numeroFichajes + " guardados, " +
            "correctamente. Un fichaje de producción ha sufrido un error al intentar enviarse al servidor. Comprueba la conexion a internet. Mensaje del servidor: " + mensajeServicio;
          return mensaje;
        } else {
          mensaje = "Ha ocurrido un error: Se han enviado al servidor " + numeroFichajesProduccionCorrectos + " fichajes de produccion de los " + numeroFichajes + " guardados correctamente. Un fichaje de producción ha sufrido un error al intentar enviarse al servidor. " +
            "Comprueba la conexion a internet. Mensaje del servidor: " + mensajeServicio;
          return mensaje;
        }
      } else if (numeroFichajesIncorrectos > 0) {
        if (numeroFichajesProduccionCorrectos > 0) {
          mensaje = "Ha ocurrido un error: Se han enviado al servidor " + numeroFichajesProduccionCorrectos + " fichajes de produccion y " + numeroFichajesCorrectos + " fichajes normales de los " + numeroFichajes + " guardados, " +
            "correctamente. Un fichaje normal ha sufrido un error al intentar enviarse al servidor. Comprueba la conexion a internet. Mensaje del servidor: " + mensajeServicio;
          return mensaje;
        } else {
          mensaje = "Ha ocurrido un error: Se han enviado al servidor " + numeroFichajesCorrectos + " de los " + numeroFichajes + " fichajes normales guardados correctamente. Un fichaje normal ha sufrido un error al intentar enviarse al servidor. " +
            "Comprueba la conexion a internet. Mensaje del servidor: " + mensajeServicio;
          return mensaje;
        }

      } else if (numeroFichajesProduccionIncorrectos > 0) {
        if (numeroFichajesCorrectos > 0) {
          mensaje = "Ha ocurrido un error: Se han enviado al servidor " + numeroFichajesProduccionCorrectos + " fichajes de produccion y " + numeroFichajesCorrectos + " fichajes normales de los " + numeroFichajes + " guardados, " +
            "correctamente. Un fichaje de produccion ha sufrido un error al intentar enviarse al servidor. Comprueba la conexion a internet. Mensaje del servidor: " + mensajeServicio;
          return mensaje;
        } else {
          mensaje = "Ha ocurrido un error: Se han enviado al servidor " + numeroFichajesProduccionCorrectos + " de los " + numeroFichajes + " fichajes de produccion guardados correctamente. Un fichaje de produccion ha sufrido un error al intentar enviarse al servidor. " +
            "Comprueba la conexion a internet. Mensaje del servidor: " + mensajeServicio;
          return mensaje;
        }
      }
    } else if (erroresServicio == false && erroresServicioSecundario == true) {
      if (numeroFichajesCorrectos > 0 && numeroFichajesProduccionCorrectos > 0) {
        mensaje = "Se han enviado al servidor " + numeroFichajesProduccionCorrectos + " fichajes de produccion y " + numeroFichajesCorrectos + " fichajes normales de los " + numeroFichajes + " fichajes guardados correctamente al servidor. Uno de los fichajes de la lista no es válido" +
          " y se ha eliminado de la lista. Mensaje de error: " + mensajeServicio;
        return mensaje;
      } else if (numeroFichajesCorrectos > 0 && numeroFichajesProduccionCorrectos == 0) {
        mensaje = "Se han enviado al servidor " + numeroFichajesCorrectos + " fichajes normales correctamente de los " + numeroFichajes + " guardados correctamente. Uno de los fichajes de los lista no es válido y se ha eliminado de la lista." +
          " Mensaje de error: ", mensajeServicio;
        return mensaje;
      } else if (numeroFichajesCorrectos == 0 && numeroFichajesProduccionCorrectos > 0) {
        mensaje = "Se han enviado al servidor " + numeroFichajesProduccionCorrectos + " fichajes de produccion de los " + numeroFichajes + " guardados correctamente. Uno de los fichajes de la lista no es válido y se ha eliminado de la lista." +
          " Mensaje de errror: " + mensajeServicio;
        return mensaje;
      }
    } else if (erroresServicioSecundario == false && erroresServicio == false) {
      if (numeroFichajesCorrectos > 0 && numeroFichajesProduccionCorrectos > 0) {
        mensaje = "Se han enviado al servidor " + numeroFichajesProduccionCorrectos + " fichajes de produccion y " + numeroFichajesCorrectos + " fichajes normales de los " + numeroFichajes + " fichajes guardados correctamente al servidor.";
        return mensaje;
      } else if (numeroFichajesCorrectos > 0 && numeroFichajesProduccionCorrectos == 0) {
        mensaje = "Se han enviado al servidor " + numeroFichajesCorrectos + " fichajes normales correctamente de los " + numeroFichajes + " guardados correctamente.";
        return mensaje;

      } else if (numeroFichajesCorrectos == 0 && numeroFichajesProduccionCorrectos > 0) {
        mensaje = "Se han enviado al servidor " + numeroFichajesProduccionCorrectos + " fichajes de produccion de los " + numeroFichajes + " guardados correctamente.";
        return mensaje;
      }
    }

    return mensaje;
  }

  

  


  async dissmisLoading() {
    if (this.loadingObject) {
      this.loadingCtrl.dismiss()
      this.loadingObject = null;
    };

  }

}
